import { render, staticRenderFns } from "./PaletteForm.vue?vue&type=template&id=121ab6b6"
import script from "./PaletteForm.vue?vue&type=script&lang=js"
export * from "./PaletteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports